import { useLang } from '../../i18n/LanguageContext'

export default function Step1Welcome({ tokenData, onNext }) {
  const { t, locale } = useLang()
  const needs = t('onboarding.step1NeedsList')

  return (
    <div className="wizard__body">
      <div style={{ textAlign: 'center', marginBottom: 'var(--space-6)' }}>
        <div style={{
          width: 56, height: 56, margin: '0 auto 1.5rem',
          background: 'var(--color-primary-50)', borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: 'var(--color-primary)', fontSize: '1.5rem'
        }}>
          🏢
        </div>
      </div>

      <h1 className="wizard__title" style={{ textAlign: 'center' }}>
        {t('onboarding.step1Title')}
      </h1>
      <p className="wizard__subtitle" style={{ textAlign: 'center' }}>
        {t('onboarding.step1Subtitle')}
      </p>

      {tokenData?.tenantName && (
        <div className="alert alert--success" style={{ marginBottom: '1.5rem' }}>
          <strong>{t('onboarding.step1Suggested')}</strong> {tokenData.tenantName}
        </div>
      )}

      {tokenData?.email && (
        <div style={{ marginBottom: '1.5rem', textAlign: 'center' }}>
          <span style={{ color: 'var(--color-gray-500)', fontSize: 'var(--font-size-sm)' }}>
            {t('onboarding.step1SentTo')} <strong>{tokenData.email}</strong>
          </span>
        </div>
      )}

      <div style={{ textAlign: 'center', marginBottom: '1rem', color: 'var(--color-gray-500)', fontSize: 'var(--font-size-sm)' }}>
        {t('onboarding.step1Expires')} {new Date(tokenData?.expiresAt).toLocaleDateString(locale, {
          day: 'numeric', month: 'long', year: 'numeric'
        })}
      </div>

      <div style={{ marginTop: '2rem' }}>
        <h3 style={{ fontSize: 'var(--font-size-base)', fontWeight: 600, marginBottom: '1rem', color: 'var(--color-gray-700)' }}>
          {t('onboarding.step1Needs')}
        </h3>
        <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          {needs.map((item, i) => (
            <li key={i} style={{
              display: 'flex', alignItems: 'center', gap: '0.75rem',
              fontSize: 'var(--font-size-sm)', color: 'var(--color-gray-600)'
            }}>
              <span style={{
                width: 24, height: 24, borderRadius: '50%',
                background: 'var(--color-primary-light)', color: 'var(--color-primary)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '0.75rem', fontWeight: 700, flexShrink: 0
              }}>
                {i + 1}
              </span>
              {item}
            </li>
          ))}
        </ul>
      </div>

      <div className="wizard__actions" style={{ justifyContent: 'center' }}>
        <button className="btn btn--primary btn--lg" onClick={onNext}>
          {t('onboarding.step1Start')}
        </button>
      </div>
    </div>
  )
}
